// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////
import * as components from "../../js/components";
import * as constants from "../../js/constants";
import * as utils from "../../js/utils";
// TODO default export const page //////////////////////////////////////////////////////////////////////////////////////
export const ServiceRecordPage = () => {
  // TODO react hooks variables ////////////////////////////////////////////////////////////////////////////////////////
  const dispatch = useDispatch();
  // TODO custom variables /////////////////////////////////////////////////////////////////////////////////////////////
  const [dateTime, dateTimeSet] = useState(utils.GetCurrentDate(false));
  // TODO react store variables ////////////////////////////////////////////////////////////////////////////////////////
  const servicerecordUserStore = useSelector((state) => state.servicerecordUserStore);
  const {
    load: loadServiceRecordUser,
    data: dataServiceRecordUser,
  } = servicerecordUserStore;
  // TODO handlers /////////////////////////////////////////////////////////////////////////////////////////////////////
  const handlerSubmit = async (e) => {
    try { e.preventDefault(); } catch (error) {}
    const form = {
      "Action-type": "USER_SERVICERECORD",
      dateTime: `${dateTime.split("-")[0]}${dateTime.split("-")[1]}${dateTime.split("-")[2]}`,
    };
    dispatch(
      utils.ActionConstructorUtility(
        form, "/api/auth/servicerecord/", "POST", 30000,
        constants.USER_SERVICERECORD
      )
    );
  };
  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="m-0 p-0">
      <components.HeaderComponent />
      <main>
        <div style={{ padding: "28px 32px 32px" }}>

          {/* ===== ФОРМА ВЫБОРА ДАТЫ ===== */}
          <div className="custom-card m-0 p-0 mb-4" style={{ maxWidth: 480 }}>
            <div style={{
              padding: "16px 20px",
              borderBottom: "1px solid var(--km-line)",
              display: "flex", alignItems: "center", gap: 10
            }}>
              <i className="fa-solid fa-id-card-clip" style={{ color: "#1A8FB8", fontSize: 18 }} />
              <span style={{ fontWeight: 700, fontSize: 15 }}>Послужной список</span>
            </div>
            <div style={{ padding: "20px" }}>
              <p style={{ fontSize: 13, color: "var(--km-text-soft)", margin: "0 0 16px" }}>
                Выберите дату и нажмите «Получить»
              </p>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                <div style={{ flex: "1 1 200px" }}>
                  <label style={{ fontSize: 11.5, fontWeight: 600, color: "var(--km-text-soft)", display: "block", marginBottom: 5 }}>
                    Дата
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    min={utils.GetCurrentDate(false)}
                    max={utils.GetCurrentDate(false, 1)}
                    value={dateTime}
                    required
                    onChange={(e) => dateTimeSet(e.target.value)}
                    style={{ borderRadius: 8, height: 40, fontSize: 14 }}
                  />
                </div>
                <div style={{ flex: "0 0 auto" }}>
                  {!loadServiceRecordUser ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handlerSubmit}
                      style={{ height: 40, fontWeight: 600, borderRadius: 8, paddingLeft: 18, paddingRight: 18 }}
                    >
                      <i className="fa-solid fa-circle-check m-0 p-1" />
                      Получить
                    </button>
                  ) : (
                    <button className="btn btn-primary" disabled style={{ height: 40, borderRadius: 8, paddingLeft: 18, paddingRight: 18 }}>
                      <span className="spinner-border spinner-border-sm m-0 me-2" />
                      Загрузка...
                    </button>
                  )}
                </div>
              </div>
              <div style={{
                marginTop: 14, padding: "9px 12px", background: "#FBEAEA",
                borderRadius: 8, display: "flex", alignItems: "flex-start", gap: 8,
                fontSize: 12.5, color: "var(--km-danger)"
              }}>
                <i className="fa-solid fa-circle-exclamation" style={{ marginTop: 2, flexShrink: 0 }} />
                Если после ожидания данных нет — попробуйте ещё 1–2 раза или подождите полчаса.
              </div>
            </div>
          </div>

          {/* ===== РЕЗУЛЬТАТ ===== */}
          <components.StoreStatusComponent
            storeStatus={servicerecordUserStore}
            keyStatus={"servicerecordUserStore"}
            consoleLog={constants.DEBUG_CONSTANT}
            showLoad={true} loadText={""}
            showData={false} dataText={"Данные успешно получены!"}
            showError={true} errorText={""}
            showFail={true} failText={""}
          />
          {dataServiceRecordUser && (
            <div className="m-0 p-0">
              <div className="custom-card m-0 p-0 mb-3" style={{ maxWidth: 560 }}>
                <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--km-line)", fontWeight: 700, fontSize: 14 }}>
                  <i className="fa-solid fa-id-card-clip m-0 p-1" style={{ color: "#1A8FB8" }} />
                  Данные по послужному списку
                </div>
                <table className="table table-sm table-striped table-hover m-0">
                  <thead>
                    <tr>
                      <th className="text-start p-2 w-50">Тип</th>
                      <th className="text-end p-2">Значение</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataServiceRecordUser["headers"].map((head, index) => (
                      <tr key={index}>
                        <td className="text-start p-2">{head[0]}</td>
                        <td className={
                          index !== 4
                            ? "text-end p-2"
                            : head[1] >= 0
                            ? "text-end text-success fw-bold p-2"
                            : "text-end text-danger fw-bold p-2"
                        }>
                          {head[1]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {dataServiceRecordUser["tables"] && dataServiceRecordUser["tables"].length > 0 && (
                <components.AccordionComponent
                  key_target={"accordion1"}
                  isCollapse={false}
                  title={"Послужной список"}
                  text_style="text-primary"
                  header_style="bg-primary bg-opacity-10 custom-background-transparent-low"
                  body_style="bg-light bg-opacity-10 custom-background-transparent-low"
                >
                  <div className="row row-cols-1 row-cols-lg-2 g-3 m-0 p-2" style={{ "--bs-gutter-x": "1rem", marginLeft: 0, marginRight: 0 }}>
                    {dataServiceRecordUser["tables"].map((table, index) => (
                      <div key={index} className="m-0 p-0">
                        <div className="custom-card m-0 p-0">
                          <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--km-line)", fontWeight: 700, fontSize: 13, textAlign: "center" }}>
                            {dataServiceRecordUser["tables"].length > 1 ? table[0] : `${table[0]}`.slice(0, 10)}
                          </div>
                          <table className="table table-sm table-striped table-hover m-0">
                            <thead>
                              <tr>
                                <th className="text-start p-2 w-50">Тип</th>
                                <th className="text-end p-2">Значение</th>
                              </tr>
                            </thead>
                            <tbody>
                              {table.slice(1).map((tab, i) => (
                                <tr key={i}>
                                  <td className="text-start p-2">{tab[0]}</td>
                                  <td className="text-end p-2">{tab[1]}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>
                </components.AccordionComponent>
              )}
            </div>
          )}
        </div>
      </main>
      <components.FooterComponent />
    </div>
  );
};
